import React, { useEffect, useState } from 'react'
import * as opdRegisteredCrud from '../../../configurations/crud/opdRegisteredCrud'
import { useToast } from '../../controls/Toast/ToastService';
import {
    MdErrorOutline,
    MdOutlineTag,
    MdOutlineConfirmationNumber,
    MdOutlinePhone,
    MdOutlineCake,
    MdOutlineHome,
    MdCheck,
} from 'react-icons/md';
import { Link, useParams } from 'react-router-dom';
import { PAGE_SIZE } from '../../../configurations/initUrls';
import Paging from '../../controls/Paging';
import ConfirmOnline from './ConfirmOnline';
import { EOPDRegisteredStatusBg, GetEOPDRegisterstatus, GetEOPDRegisterStatusName } from '../../../configurations/enums/EOPDRegisteredStatus';
import StatusContainer from '../../controls/StatusContainer';
import { IoCheckmarkCircleOutline } from 'react-icons/io5';
import LoadingContainer from '../../controls/LoadingContainer';
import { GetEGenderName } from '../../../configurations/enums/EGender';
import useGlobalLoader from '../../../configurations/useGlobalLoader';
import Empty from '../../controls/Empty';

export default function LookOutRegistered({ isActive, searchTerm, isSearch, centerId, forDate }) {

    const { start, end } = useGlobalLoader()
    const toast = useToast()
    const [LastPage, setLastPage] = useState(1);
    const [pagingData, setPagingData] = useState();
    const [loding, setLoding] = useState(false)
    const [userData, setUserData] = useState([]);
    const [lodingCrud, setLodingCrud] = useState(false)
    const [isOpenAdd, setIsOpenAdd] = useState(false)
    const [addData, setAddData] = useState()
    const [currentPage, setCurrentPage] = useState(1)

    useEffect(() => {
        if (isActive && centerId && forDate) {
            onSearch()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSearch, centerId, forDate])

    const OnPageChange = (e) => {
        if (isActive && centerId && forDate) {
            setCurrentPage(e)
            GetTodaysRegistered({
                CenterId: centerId,
                PageNo: e,
                PageSize: PAGE_SIZE,
                SearchTerm: searchTerm,
                ForDate: forDate
            })
        }
    }

    const onSearch = () => {
        GetTodaysRegistered({
            CenterId: centerId,
            PageNo: 1,
            PageSize: PAGE_SIZE,
            SearchTerm: searchTerm,
            ForDate: forDate
        })
    }

    const GetTodaysRegistered = (params) => {
        setLoding(true)
        start()
        opdRegisteredCrud.GetForDateRegistered(params).then(res => {
            let mdata = res.data
            if (mdata.result.succeeded) {
                setUserData(mdata.data)
                setPagingData(mdata.paging)
                setLastPage(mdata.paging.pageCount)
            } else {
                setPagingData()
                setLastPage(1)
                setUserData([])
                toast.open(mdata.result.message, <MdErrorOutline />, "danger")
            }
            setLoding(false)
            end()
        }).catch(errors => {
            setPagingData()
            setLastPage(1)
            setUserData([])
            setLoding(false)
            end()
            toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
        })
    }

    const confirmOnline = (param, setValues) => {
        setLodingCrud(true)
        start()
        opdRegisteredCrud.ConfirmOnline(param).then(res => {
            let mdata = res.data
            if (mdata.result.succeeded) {
                setValues({
                    Id: 0,
                    Comment: "N/A",
                    BloodPressure: "N/A",
                })
                setIsOpenAdd(false)
                onSearch()
                toast.open(
                    <div className='flex flex-col'>
                        <span>Confirmed Successfully! Ref No: {mdata.data.id}</span>
                        <a href={`/#/checkconfirmed/${mdata.data.id}`} target='_blank' className='hover:underline text-blue-700 font-semibold' >Click to get confirmation details</a>
                    </div>
                    , <IoCheckmarkCircleOutline />, "success", 30000)
            } else {
                toast.open(mdata.result.message, <MdErrorOutline />, "danger")
                setIsOpenAdd(false)
            }
            setLodingCrud(false)
            end()
        }).catch(errors => {
            setLodingCrud(false)
            end()
            setIsOpenAdd(false)
            toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
        })
    }

    // Confirm button (pending) OR status badge
    const renderAction = (item) => (
        item.status == 2 ? (
            <button
                type="button"
                title="Pending"
                onClick={() => { setAddData(item.id); setIsOpenAdd(!isOpenAdd) }}
                className="inline-flex items-center gap-1.5 rounded-lg bg-brand-500 px-3 py-1.5 text-sm font-medium text-white transition hover:bg-brand-600 focus:outline-none focus:ring-2 focus:ring-brand-500 active:scale-95"
            >
                <MdCheck className="text-base" /> Confirm
            </button>
        ) : (
            <StatusContainer bg={EOPDRegisteredStatusBg(item.status)} text={GetEOPDRegisterStatusName(item.status)} />
        )
    )

    return (
        <div className="text-gray-700">
            <Paging LastPage={LastPage} CurrentPage={currentPage} OnPageChange={OnPageChange} pagingData={pagingData}>

                {loding ? (
                    <LoadingContainer text="Fetching..." />
                ) : userData.length > 0 ? (
                    <>
                        {/* ===== desktop table ===== */}
                        <div className="hidden overflow-x-auto rounded-xl ring-1 ring-gray-100 sm:block">
                            <table className="w-full border-collapse text-left text-sm text-gray-500">
                                <thead>
                                    <tr className="bg-gray-100 text-xs uppercase tracking-wide text-gray-500">
                                        <th scope="col" className="px-3 py-3 font-semibold">
                                            <span className="flex items-center gap-1"><MdOutlineTag className="text-sm" /> Ref.No</span>
                                        </th>
                                        <th scope="col" className="px-3 py-3 font-semibold">
                                            <span className="flex items-center gap-1"><MdOutlineConfirmationNumber className="text-sm" /> OPD No.</span>
                                        </th>
                                        <th scope="col" className="px-3 py-3 font-semibold">Name</th>
                                        <th scope="col" className="px-3 py-3 font-semibold">
                                            <span className="flex items-center gap-1"><MdOutlinePhone className="text-sm" /> Phone</span>
                                        </th>
                                        <th scope="col" className="px-3 py-3 font-semibold">
                                            <span className="flex items-center gap-1"><MdOutlineCake className="text-sm" /> Age</span>
                                        </th>
                                        <th scope="col" className="px-3 py-3 font-semibold">Action</th>
                                        <th scope="col" className="px-3 py-3 font-semibold">
                                            <span className="flex items-center gap-1"><MdOutlineHome className="text-sm" /> Address</span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody className="divide-y divide-gray-100">
                                    {userData.map((item, index) => (
                                        <tr key={item.id ?? index} className="bg-white hover:bg-gray-50">
                                            <td className="px-3 py-2.5">{item.id}</td>
                                            <td className="px-3 py-2.5">{item.opdNumberAlloted}</td>
                                            <td className="whitespace-nowrap px-3 py-2.5 font-bold text-gray-800">
                                                {item.patientName} <span className="text-[9px] font-normal text-gray-400">({GetEGenderName(item.gender)})</span>
                                            </td>
                                            <td className="px-3 py-2.5">
                                                {item.mobile
                                                    ? <a href={`tel:${item.mobile}`} className="hover:text-brand-600 hover:underline">{item.mobile}</a>
                                                    : "—"}
                                            </td>
                                            <td className="px-3 py-2.5">{item.age}</td>
                                            <td className="w-28 px-3 py-2.5">{renderAction(item)}</td>
                                            <td className="whitespace-nowrap px-3 py-2.5">{item.patientAddress}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        {/* ===== mobile cards ===== */}
                        <div className="space-y-2 p-2 text-left sm:hidden">
                            {userData.map((item, index) => (
                                <div key={item.id ?? index} className="rounded-xl border border-gray-100 bg-white p-3 shadow-sm">
                                    <div className="flex items-start justify-between gap-2">
                                        <div className="min-w-0">
                                            <div className="font-bold text-gray-900">
                                                {item.patientName} <span className="text-xs font-normal text-gray-400">({GetEGenderName(item.gender)})</span>
                                            </div>
                                            <div className="mt-0.5 flex flex-wrap items-center gap-x-2 gap-y-0.5 text-xs text-gray-500">
                                                <span className="flex items-center gap-0.5"><MdOutlineTag className="text-sm" /> {item.id}</span>
                                                <span className="flex items-center gap-0.5"><MdOutlineConfirmationNumber className="text-sm" /> {item.opdNumberAlloted}</span>
                                                <span className="flex items-center gap-0.5"><MdOutlineCake className="text-sm" /> {item.age} Y</span>
                                            </div>
                                        </div>
                                        <div className="shrink-0">{renderAction(item)}</div>
                                    </div>
                                    <div className="mt-2 space-y-1 text-xs text-gray-600">
                                        <div className="flex items-center gap-1">
                                            <MdOutlinePhone className="shrink-0 text-sm text-gray-400" />
                                            {item.mobile
                                                ? <a href={`tel:${item.mobile}`} className="hover:text-brand-600 hover:underline">{item.mobile}</a>
                                                : "—"}
                                        </div>
                                        <div className="flex items-start gap-1">
                                            <MdOutlineHome className="mt-0.5 shrink-0 text-sm text-gray-400" />
                                            <span>{item.patientAddress}</span>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </>
                ) : (
                    <Empty>No Items Found.</Empty>
                )}
            </Paging>

            <div className="pb-4" />

            <ConfirmOnline ConfirmOnline={confirmOnline} id={addData} isOpen={isOpenAdd} setIsOpen={setIsOpenAdd} loding={lodingCrud} />
        </div>
    )
}